// Unpublished Work © 2021-2026 Deere & Company

import t from 'tcomb';
import {DigitalUserAccountSearch} from './digital-user-account-search';
import {Search} from './search';
import {Profile} from './profile';
import {SelectBusinessContact} from './select-business-contact';
import {AddCustomer} from './add-customer';

export const Features = t.struct({
    addCustomer: AddCustomer,
    digitalUserAccountSearch: DigitalUserAccountSearch,
    profile: Profile,
    search: Search,
    selectBusinessContact: SelectBusinessContact
}, {
    defaultProps: {
        addCustomer: AddCustomer({}),
        digitalUserAccountSearch: DigitalUserAccountSearch({}),
        profile: Profile({}),
        search: Search({}),
        selectBusinessContact: SelectBusinessContact({})
    },
    name: 'Features',
    strict: true
});
